import { FC, useCallback, useMemo } from 'react';
import { useFilterContext } from 'entities/broadcast';
import { EElementSize } from 'shared/types';
import { DateField } from 'shared/ui';
import { DatePickerStyled } from './broadcast-filter-date.styled';

export const BroadcastFilterDate: FC = () => {
  const { startDate, endDate, setEndDate, setStartDate, setOffset } =
    useFilterContext();

  const dateRange = useMemo(() => {
    if (startDate && endDate) {
      return [startDate, endDate];
    } else return [];
  }, [endDate, startDate]);

  const setRange = useCallback(
    ([startDate, endDate]: Date[]) => {
      setStartDate(startDate);
      setEndDate(endDate);
      setOffset(0);
    },
    [setEndDate, setOffset, setStartDate],
  );

  return (
    <DatePickerStyled>
      <DateField
        $size={EElementSize.M}
        placeholder="Выберите дату"
        range={dateRange}
        onDateChange={setRange}
      />
    </DatePickerStyled>
  );
};
